import { render, staticRenderFns } from "./history-map-legend.vue?vue&type=template&id=4801957c"
import script from "./history-map-legend.vue?vue&type=script&lang=js"
export * from "./history-map-legend.vue?vue&type=script&lang=js"
import style0 from "./history-map-legend.vue?vue&type=style&index=0&id=4801957c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports